var React = require('react');

function FbiconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.51 30.41l6.61 0 2.65 -10.58 -9.26 0 0 -5.28c0,-2.73 0,-5.29 5.29,-5.29l3.97 0 0 -8.89c-0.86,-0.11 -4.12,-0.37 -7.56,-0.37 -7.18,0 -12.28,4.38 -12.28,12.43l0 7.4 -7.93 0 0 10.58 7.93 0 0 22.48 10.58 0 0 -22.48z"}));
}

FbiconInline.defaultProps = {"width":"16","height":"30","viewBox":"0 0 27.77 52.89"};

module.exports = FbiconInline;

FbiconInline.default = FbiconInline;
